import api from './api';

const DashboardService = {
  load: (startDate, endDate, currentDate, lastWeek) =>
    api.get(`dashboards`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        current_date: currentDate,
        last_week: lastWeek,
      },
    }),
  getPrizesByAward: (awardId, filter) =>
    api.get(`dashboards/get-prizes-by-award`, {
      params: { awardId, filter },
    }),
  export: (start, end, awards) =>
    api.post(`dashboards/export`, { awards, start, end }),
};

export default DashboardService;
